<app-map-city></app-map-city>

<app-map-stops [stops]="service.cities"></app-map-stops>

<app-map-vehicles [vehiclesAll]="service.vehiclesAll" [(vehicles)]="service.vehicles"></app-map-vehicles>

<div *ngFor="let conn of connections" class="line" [style]="conn.style"></div>

<div class="row" *ngFor="let row of map">
	<div class="col-sm" *ngFor="let pos of row">
		<div
			class="btn btn-outline-secondary pos"
			*ngIf="pos.name"
			[ngClass]="{ 'btn-outline-danger': pos.type === 'BR' }"
			(click)="citySelect(pos)"
			[attr.disabled]="!service.vehicleSelected || !service.editable"
			[id]="'city' + pos.id"
		>
			<b>{{ pos.name }}</b>
			<br />
			<span *ngIf="pos.destinations.length">
				{{ pos.destinations.length }}
			</span>
		</div>
	</div>
</div>

<div *ngIf="showAdditionalCities">
	<fieldset class="m-2 p-2" [disabled]="!service.vehicleSelected || !service.editable">
		<legend>Przystanki Przelotowe</legend>
		<div class="btn btn-secondary me-4 mb-2" (click)="stopsManage('CR')">
			<i class="fas fa-pencil-alt"></i> Zarządzaj
		</div>
		<div
			class="btn btn-primary btn-lg me-4 mb-2"
			*ngFor="let pos of service.stops.CR"
			(click)="stopSet(pos)"
			[id]="'city' + pos.id"
		>
			{{ pos.name }}
		</div>
	</fieldset>

	<fieldset class="m-2 p-2 text-center" [disabled]="!service.vehicleSelected || !service.editable">
		<div
			class="btn btn-lg btn-danger me-4"
			*ngFor="let pos of service.destinations"
			(click)="destinationSet(pos)"
			[id]="'city' + pos.id"
		>
			{{ pos.name }}
		</div>
	</fieldset>

	<fieldset class="m-2 p-2" [disabled]="!service.vehicleSelected || !service.editable">
		<legend>Przystanki Wysiadkowe</legend>
		<div class="btn btn-secondary me-4 mb-2" (click)="stopsManage('DO')">
			<i class="fas fa-pencil-alt"></i> Zarządzaj
		</div>
		<div
			class="btn btn-primary btn-lg me-4 mb-2"
			*ngFor="let pos of service.stops.DO"
			(click)="stopSet(pos)"
			[id]="'city' + pos.id"
		>
			{{ pos.name }}<br />
			<small>{{ pos.address }}</small>
		</div>
	</fieldset>
</div>
<br />
